import { getWrestlerName, getWrestlerNameUpper, wrestlerMatchesSearch } from './wrestlerUtils';
import React, { useState } from 'react';
import { getClassIcon, getRoleIcon, getXPBadge } from './wrestlerIcons';
import placeholder from '../assets/placeholder.png';
import background from '../assets/Background_Test.jpg';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};

const BRAND_LOGOS = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
const BRAND_BGS = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };
const CLASS_COLORS = { 'Fighter': '#3498db', 'Bruiser': '#e74c3c', 'Cruiser': '#2ecc71', 'Specialist': '#9b59b6', 'Giant': '#e67e22' };


const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .row-hover:hover { background: rgba(255,255,255,0.07) !important; }
  .row-hover { cursor: pointer; transition: background 0.12s; }
  .row-sel { background: rgba(255,255,255,0.1) !important; }
  .btn-add:hover { background: rgba(46,204,113,0.2) !important; border-color: #2ecc71 !important; color: #2ecc71 !important; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.7) !important; color: #fff !important; }
  .pick-card:hover { outline: 1.5px solid rgba(255,255,255,0.4) !important; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
  select option { background: #1a1a1a; color: #fff; }
`;

const S = {
  panel: { background: 'rgba(8,8,8,0.88)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '10px', boxShadow: '0 20px 80px rgba(0,0,0,0.9)' },
  title: { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#fff', textShadow: '0 0 28px rgba(180,0,0,0.5)' },
  btn: { fontFamily: "'Monda', sans-serif", letterSpacing: '1.5px', fontSize: '0.62rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.35)', color: 'rgba(255,255,255,0.8)', padding: '9px 28px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.18s, border-color 0.18s, color 0.18s' },
  input: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '4px', padding: '7px 12px', color: '#fff', fontSize: '0.62rem', fontFamily: "'Monda', sans-serif", outline: 'none' },
  th: { fontFamily: "'Monda', sans-serif", fontSize: '0.5rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.38)', padding: '7px 8px', borderBottom: '1px solid rgba(255,255,255,0.07)', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' },
  mono: { fontFamily: "'Monda', sans-serif" },
  anton: { fontFamily: "'Anton', sans-serif" },
};

function getFiltered(pool, draftedIds, search, sortKey, sortDir) {
  let list = pool.filter(w => !draftedIds.includes(w._uid));
  if (search) list = list.filter(w => wrestlerMatchesSearch(w, search));
  list = [...list].sort((a, b) => {
    if (sortKey === 'xp') {
      const diff = (a.starting_xp || 0) - (b.starting_xp || 0);
      return sortDir === 'asc' ? diff : -diff;
    }
    let va = '', vb = '';
    if (sortKey === 'name') { va = getWrestlerName(a, 'full') || ''; vb = getWrestlerName(b, 'full') || ''; }
    else if (sortKey === 'gender') { va = a.gender || ''; vb = b.gender || ''; }
    else if (sortKey === 'class') { va = a.fight_class || ''; vb = b.fight_class || ''; }
    else if (sortKey === 'role') { va = a.heel ? 'b' : 'a'; vb = b.heel ? 'b' : 'a'; }
    const cmp = va.localeCompare(vb);
    return sortDir === 'asc' ? cmp : -cmp;
  });
  return list;
}

export default function DraftPage({ roster, brand, customLogo, customBg, customColor, onFinish, onBack, preSelected, onComplete }) {
  const brandColor = customColor || BRAND_COLORS[brand] || '#d4af37';
  const brandLogo = customLogo || BRAND_LOGOS[brand];
  const brandBg = customBg || BRAND_BGS[brand];

  const pool = roster.filter(w => w.status === 'active').map((w, i) => ({ ...w, _uid: `${w.wrestler_id}-${i}` }));

  const [draftedIds, setDraftedIds] = useState([]);
  const [picks, setPicks] = useState(preSelected || []);
  var handleFinish = onComplete || onFinish;
  const [hoveredW, setHoveredW] = useState(null);
  const [selectedW, setSelectedW] = useState(null);
  const [search, setSearch] = useState('');
  const [sortKey, setSortKey] = useState('name');
  const [sortDir, setSortDir] = useState('asc');

  const activeW = hoveredW || selectedW;
  const filtered = getFiltered(pool, draftedIds, search, sortKey, sortDir);

  const handleSort = (key) => {
    if (key === sortKey) {
      setSortDir(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  const handleAdd = (w) => {
    setPicks(prev => [...prev, w]);
    setDraftedIds(prev => [...prev, w._uid]);
    if (selectedW?.wrestler_id === w.wrestler_id) setSelectedW(null);
    if (hoveredW?.wrestler_id === w.wrestler_id) setHoveredW(null);
  };

  const handleUndo = () => {
    if (picks.length === 0) return;
    const last = picks[picks.length - 1];
    setPicks(prev => prev.slice(0, -1));
    setDraftedIds(prev => prev.filter(id => id !== last._uid));
  };

  const handleSelectSort = (e) => {
    const val = e.target.value;
    const lastDash = val.lastIndexOf('-');
    setSortKey(val.slice(0, lastDash));
    setSortDir(val.slice(lastDash + 1));
  };

  const thStyle = (key) => ({
    ...S.th,
    color: sortKey === key ? '#fff' : 'rgba(255,255,255,0.38)',
  });

  const thLabel = (label, key) => `${label}${sortKey === key ? (sortDir === 'asc' ? ' ↑' : ' ↓') : ''}`;

  const maleCount = picks.filter(w => w.gender === 'M').length;
  const femaleCount = picks.filter(w => w.gender === 'F').length;
  const heelCount = picks.filter(w => w.heel).length;
  const faceCount = picks.filter(w => !w.heel).length;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 600 }}>
      <style>{css}</style>
      <img loading="lazy" src={background} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
      {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.2, zIndex: 1 }} />}
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.85) 100%)', zIndex: 2 }} />

      <div style={{ position: 'absolute', inset: 0, zIndex: 6, display: 'flex', flexDirection: 'column', padding: '70px 20px 16px', gap: '10px', overflow: 'hidden' }}>
        <div style={{ ...S.title, fontSize: '1.4rem', flexShrink: 0 }}>DRAFT</div>

        <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '240px 1fr 280px', gap: '14px', overflow: 'hidden', minHeight: 0 }}>

          {/* LEFT */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden' }}>
            <div style={{ ...S.title, fontSize: '0.9rem', textAlign: 'center' }}>SUPERSTARS</div>
            <div style={{ borderRadius: '10px', overflow: 'hidden', border: `1px solid ${brandColor}44`, position: 'relative', flex: 1, display: 'flex', flexDirection: 'column', maxHeight: '420px' }}>
              {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(4px) brightness(0.4)', zIndex: 0 }} />}
              <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${brandColor}22 0%, transparent 70%)`, zIndex: 1 }} />
              <div style={{ position: 'relative', zIndex: 2, display: 'flex', justifyContent: 'center', padding: '12px 10px 4px' }}>
                {brandLogo ? <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '65px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} /> : <div style={{ ...S.title, fontSize: '0.9rem', color: brandColor }}>{brand}</div>}
              </div>
              <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflow: 'hidden', paddingTop: '8px' }}>
                <img loading="lazy" src={getWrestlerRender(activeW) || placeholder} alt="superstar" style={{ width: '130%', maxWidth: '280px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.9))', marginBottom: '-20%' }} />
              </div>
              <div style={{ position: 'relative', zIndex: 2, padding: '8px 12px 14px', background: 'rgba(0,0,0,0.75)', borderTop: `1px solid ${brandColor}33`, textAlign: 'center' }}>
                <div style={{ ...S.anton, fontSize: '0.8rem', letterSpacing: '2px', color: '#fff', marginBottom: '10px' }}>{activeW ? getWrestlerNameUpper(activeW, 'display') : 'SUPERSTAR'}</div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                  {activeW ? (
                    <>
                      <img loading="lazy" src={getClassIcon(activeW.fight_class)} alt={activeW.fight_class} title={activeW.fight_class}
                        style={{ width: '32px', height: '32px', objectFit: 'contain', filter: `drop-shadow(0 0 5px ${CLASS_COLORS[activeW.fight_class] || '#888'}99)` }}
                        onError={e => { e.target.style.display = 'none'; }} />
                      <img loading="lazy" src={getRoleIcon(activeW.heel)} alt={activeW.heel ? 'Heel' : 'Face'} title={activeW.heel ? 'Heel' : 'Face'}
                        style={{ width: '32px', height: '32px', objectFit: 'contain' }}
                        onError={e => { e.target.style.display = 'none'; }} />
                      <div style={{ position: 'relative', width: '32px', height: '32px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img loading="lazy" src={getXPBadge(activeW.starting_xp || 0)} alt="XP"
                          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          onError={e => { e.target.style.display = 'none'; }} />
                        <span style={{ position: 'absolute', fontFamily: "'Anton',sans-serif", fontSize: '11px', color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.9)', pointerEvents: 'none' }}>
                          {activeW.starting_xp || 0}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div style={{ height: '32px' }} />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* CENTER */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden', minHeight: 0 }}>
            <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
              <input style={{ ...S.input, flex: 2 }} placeholder="RECHERCHE"
                value={search}
                onChange={e => setSearch(e.target.value)}
                onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
              <select style={{ ...S.input, flex: 1, cursor: 'pointer' }}
                value={`${sortKey}-${sortDir}`}
                onChange={handleSelectSort}>
                <option value="name-asc">NOM A → Z</option>
                <option value="name-desc">NOM Z → A</option>
                <option value="gender-asc">GENRE A → Z</option>
                <option value="class-asc">CLASS A → Z</option>
                <option value="role-asc">ROLE A → Z</option>
                <option value="xp-desc">RING XP ↓</option>
                <option value="xp-asc">RING XP ↑</option>
              </select>
            </div>

            <div style={{ flex: 1, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '8px', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '0.4fr 2fr 0.5fr 1.2fr 0.8fr 0.6fr', background: 'rgba(0,0,0,0.6)', flexShrink: 0 }}>
                <div style={S.th} />
                <div style={thStyle('name')} onClick={() => handleSort('name')}>{thLabel('SUPERSTARS', 'name')}</div>
                <div style={thStyle('gender')} onClick={() => handleSort('gender')}>{thLabel('GENDER', 'gender')}</div>
                <div style={thStyle('class')} onClick={() => handleSort('class')}>{thLabel('CLASS', 'class')}</div>
                <div style={thStyle('role')} onClick={() => handleSort('role')}>{thLabel('ROLE', 'role')}</div>
                <div style={thStyle('xp')} onClick={() => handleSort('xp')}>{thLabel('XP', 'xp')}</div>
              </div>
              <div style={{ flex: 1, overflowY: 'auto' }}>
                {filtered.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '30px', ...S.mono, fontSize: '0.55rem', color: 'rgba(255,255,255,0.25)' }}>
                    {draftedIds.length === pool.length ? 'Tous les lutteurs ont été draftés !' : 'Aucun résultat'}
                  </div>
                )}
                {filtered.map((w, i) => {
                  const isHov = hoveredW?.wrestler_id === w.wrestler_id;
                  const isSel = selectedW?.wrestler_id === w.wrestler_id;
                  return (
                    <div key={w._uid}
                      className={`row-hover${isSel ? ' row-sel' : ''}`}
                      onMouseEnter={() => setHoveredW(w)}
                      onMouseLeave={() => setHoveredW(null)}
                      onClick={() => setSelectedW(w)}
                      style={{ display: 'grid', gridTemplateColumns: '0.4fr 2fr 0.5fr 1.2fr 0.8fr 0.6fr', background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                      <div style={{ padding: '5px 6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClick={e => { e.stopPropagation(); handleAdd(w); }}>
                        <button className="btn-add" style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.75rem', background: `${brandColor}22`, border: `1px solid ${brandColor}88`, color: brandColor, width: '26px', height: '26px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>+</button>
                      </div>
                      <div style={{ padding: '7px 8px', fontFamily: "'Anton', sans-serif", fontSize: '0.56rem', letterSpacing: '1px', color: isHov || isSel ? '#fff' : 'rgba(255,255,255,0.72)', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        {w.isCustom && <span style={{ fontSize: '0.38rem', color: '#d4af37', background: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: '2px', padding: '1px 4px', fontFamily: "'Monda',sans-serif", flexShrink: 0 }}>CUSTOM</span>}
                        {getWrestlerNameUpper(w, 'full')}
                      </div>
                      <div style={{ padding: '7px 8px', ...S.mono, fontSize: '0.46rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', display: 'flex', alignItems: 'center' }}>{w.gender === 'F' ? 'F' : 'M'}</div>
                      <div style={{ padding: '7px 8px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <img loading="lazy" src={getClassIcon(w.fight_class)} alt={w.fight_class} title={w.fight_class} style={{ width: '24px', height: '24px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                        <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: CLASS_COLORS[w.fight_class] || '#fff', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{w.fight_class}</span>
                      </div>
                      <div style={{ padding: '7px 8px', display: 'flex', alignItems: 'center' }}>
                        <img loading="lazy" src={getRoleIcon(w.heel)} alt={w.heel ? 'Heel' : 'Face'} title={w.heel ? 'Heel' : 'Face'} style={{ width: '24px', height: '24px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                      </div>
                      <div style={{ padding: '7px 8px', display: 'flex', alignItems: 'center' }}>
                        <div style={{ position: 'relative', width: '28px', height: '28px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img loading="lazy" src={getXPBadge(w.starting_xp || 0)} alt="XP" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                          <span style={{ position: 'absolute', fontFamily: "'Anton',sans-serif", fontSize: '10px', color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.9)', pointerEvents: 'none' }}>{w.starting_xp || 0}</span>
                        </div>
                      </div>

                    </div>
                  );
                })}
              </div>
            </div>

            {/* General Infos */}
            <div style={{ ...S.panel, padding: '16px 20px', flexShrink: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div style={{ ...S.anton, fontSize: '1rem', letterSpacing: '2px', color: '#fff' }}>GENERAL INFOS</div>
                <div style={{ ...S.mono, fontSize: '0.65rem', color: '#d4af37', letterSpacing: '1px' }}>{picks.length} PICK{picks.length > 1 ? 'S' : ''}</div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr', gap: '16px' }}>
                {/* GENDER */}
                <div>
                  <div style={{ ...S.mono, fontSize: '0.5rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>GENDER</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <div style={{ ...S.mono, fontSize: '0.58rem', color: 'rgba(255,255,255,0.6)' }}>♂ Male : <span style={{ color: '#fff', fontWeight: 'bold' }}>{maleCount}</span></div>
                    <div style={{ ...S.mono, fontSize: '0.58rem', color: 'rgba(255,255,255,0.6)' }}>♀ Female : <span style={{ color: '#fff', fontWeight: 'bold' }}>{femaleCount}</span></div>
                  </div>
                </div>
                {/* CLASS */}
                <div>
                  <div style={{ ...S.mono, fontSize: '0.5rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>CLASS</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    {[{ key: 'Fighter', color: '#3498db' }, { key: 'Bruiser', color: '#e74c3c' }, { key: 'Cruiser', color: '#2ecc71' }, { key: 'Specialist', color: '#9b59b6' }, { key: 'Giant', color: '#e67e22' }].map(({ key, color }) => {
                      const count = picks.filter(w => w.fight_class === key).length;
                      return (
                        <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <img loading="lazy" src={getClassIcon(key)} alt={key} style={{ width: '18px', height: '18px', objectFit: 'contain', opacity: count > 0 ? 1 : 0.25 }} onError={e => { e.target.style.display='none'; }} />
                          <span style={{ ...S.mono, fontSize: '0.55rem', color: count > 0 ? color : 'rgba(255,255,255,0.2)', textTransform: 'uppercase' }}>{key}</span>
                          <span style={{ ...S.mono, fontSize: '0.55rem', color: count > 0 ? '#fff' : 'rgba(255,255,255,0.2)', marginLeft: 'auto' }}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {/* ROLE */}
                <div>
                  <div style={{ ...S.mono, fontSize: '0.5rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.35)', marginBottom: '8px' }}>ROLE</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    {[{ key: 'heel', label: 'Heel', color: '#e74c3c' }, { key: 'face', label: 'Face', color: '#2ecc71' }].map(({ key, label, color }) => {
                      const count = key === 'heel' ? heelCount : faceCount;
                      return (
                        <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <img loading="lazy" src={getRoleIcon(key === 'heel')} alt={label} style={{ width: '18px', height: '18px', objectFit: 'contain', opacity: count > 0 ? 1 : 0.25 }} onError={e => { e.target.style.display='none'; }} />
                          <span style={{ ...S.mono, fontSize: '0.55rem', color: count > 0 ? color : 'rgba(255,255,255,0.2)', textTransform: 'uppercase' }}>{label}</span>
                          <span style={{ ...S.mono, fontSize: '0.55rem', color: count > 0 ? '#fff' : 'rgba(255,255,255,0.2)', marginLeft: 'auto' }}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT — Draft Picks */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden', minHeight: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div style={{ ...S.anton, fontSize: '0.9rem', letterSpacing: '2px', color: '#fff' }}>DRAFT <span style={{ color: brandColor }}>PICKS</span></div>
              {picks.length > 0 && (
                <button className="btn-wwe" onClick={handleUndo}
                  style={{ ...S.mono, fontSize: '0.46rem', letterSpacing: '1px', background: 'transparent', border: '1px solid rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', padding: '4px 10px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.18s, border-color 0.18s, color 0.18s' }}>
                  ↩ UNDO
                </button>
              )}
            </div>
            <div style={{ flex: 1, overflowY: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', alignContent: 'flex-start' }}>
              {picks.length === 0 && (
                <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px 20px', ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>
                  Aucun pick encore.<br />Cliquez sur + pour drafter.
                </div>
              )}
              {picks.map((w, i) => (
                <div key={w._uid} className="pick-card"
                  style={{ borderRadius: '8px', overflow: 'hidden', border: `1px solid ${brandColor}33`, position: 'relative', height: '90px', outline: '1px solid transparent', transition: 'outline 0.15s' }}>
                  {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(6px) brightness(0.35)', zIndex: 0 }} />}
                  <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1 }} />
                  <img loading="lazy" src={getWrestlerRender(w) || placeholder} alt={w.name}
                    style={{ position: 'absolute', right: '-10px', top: '-20px', height: '140%', objectFit: 'contain', objectPosition: 'top', zIndex: 2, filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))', opacity: 0.9 }} />
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 3, padding: '6px 8px', background: 'rgba(0,0,0,0.7)' }}>
                    <div style={{ ...S.anton, fontSize: '0.6rem', letterSpacing: '1.5px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getWrestlerNameUpper(w, 'full')}</div>
                    <div style={{ display: 'flex', gap: '4px', marginTop: '2px', alignItems: 'center' }}>
                      <img loading="lazy" src={getRoleIcon(w.heel)} alt={w.heel ? 'Heel' : 'Face'} style={{ width: '14px', height: '14px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                      <img loading="lazy" src={getClassIcon(w.fight_class)} alt={w.fight_class} style={{ width: '14px', height: '14px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                      <div style={{ position: 'relative', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img loading="lazy" src={getXPBadge(w.starting_xp || 0)} alt="XP" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                        <span style={{ position: 'absolute', fontFamily: "'Anton',sans-serif", fontSize: '6px', color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.9)', pointerEvents: 'none' }}>{w.starting_xp || 0}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button className="btn-wwe" onClick={() => handleFinish(picks)}
              style={{ ...S.btn, width: '100%', padding: '14px', fontSize: '0.75rem', letterSpacing: '3px', borderColor: picks.length >= 9 ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: picks.length >= 9 ? '#fff' : 'rgba(255,255,255,0.25)', flexShrink: 0 }}
              disabled={picks.length < 9}>
              FINISH DRAFT {picks.length < 9 ? '(' + picks.length + '/9)' : ''}
            </button>
            <button className="btn-wwe" onClick={onBack}
              style={{ ...S.btn, width: '100%', padding: '6px', fontSize: '0.48rem', letterSpacing: '1.5px', borderColor: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.3)', flexShrink: 0 }}>
              ← BACK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
